<template>
  <div>
    <loading v-if="isLoading" />
    <v-card>
      <v-card-text>
        <!--======= FORMULÁRIO ===================-->
        <v-container>
          <v-form ref="form" v-model="formValid" lazy-validation>
            <v-row>
              <!--======= COMBOBOX CURSO ==========-->
              <v-col class="d-flex" cols="4" sm="4">
                <v-combobox
                  v-model="editedItem.curso"
                  return-object
                  :items="cursos"
                  item-value="idCurso"
                  item-text="descricao"
                  label="Selecione o curso"
                  @change="filtrarTurma()"
                  :rules="obrigqtorioRules"
                  dense
                ></v-combobox>
              </v-col>
              <!--======= FIM COMBOBOX CURSO ==========-->

              <!--======= COMBOBOX CLASSE ==========-->
              <v-col class="d-flex" cols="4" sm="4">
                <v-combobox
                  v-model="editedItem.classe"
                  return-object
                  :items="anoacademicos"
                  item-value="idCurso"
                  item-text="descricao"
                  label="Selecione a classe"
                  @change="filtrarTurma()"
                  :rules="obrigqtorioRules"
                  dense
                ></v-combobox>
              </v-col>
              <!--======= FIM COMBOBOX CLASSE ==========-->

              <!--======= COMBOBOX TURMA ==========-->
              <v-col class="d-flex" cols="4" sm="4">
                <v-combobox
                  v-model="editedItem.turma"
                  return-object
                  :items="filtredTurmas"
                  item-value="pkTurma"
                  item-text="descricao"
                  label="Selecione a turma"
                  @change="exibirTabela()"
                  :rules="obrigqtorioRules"
                  dense
                ></v-combobox>
              </v-col>
              <!--======= FIM COMBOBOX TURMA ==========-->
            </v-row>
          </v-form>
        </v-container>
        <!--======= FIM FORMULÁRIO ===================-->
      </v-card-text>

      <div style="padding: 10px; text-align: right">
        <v-menu
          bottom
          origin="center center"
          transition="scale-transition"
          v-if="filterDisciplinas.length"
        >
          <template v-slot:activator="{ on }">
            <v-btn small fab dark color="teal" style="color: white" v-on="on">
              <v-icon small>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="bloquearTodasDisciplinas()">
              <v-icon class="mr-2" style="color: red">lock</v-icon>
              <span> Bloquear Todas as disciplinas </span>
            </v-list-item>

            <v-list-item @click="desbloquearTodasDisciplinas()">
              <v-icon class="mr-2" style="color: green">done</v-icon>
              <span> Desbloquear Todas as disciplinas </span>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>

      <!--========== TABELA ===========-->
      <v-data-table
        v-if="filterDisciplinas.length"
        :headers="headers"
        :items="filterDisciplinas"
        :sort-desc="true"
        class="elevation-1"
      >
        <template v-slot:item.index="{ item }">
          <span>{{ filterDisciplinas.indexOf(item) + 1 }}</span>
        </template>
        <template v-slot:item.classe="{ item }">
          <span>
            {{
              item.classe === 1
                ? "10ª"
                : item.classe === 2
                ? "11ª"
                : item.classe === 3
                ? "12ª"
                : item.classe === 4
                ? "13ª"
                : "N/A"
            }}
          </span>
        </template>
        <template v-slot:item.action="{ item }">
          <span v-if="item.status == 1">
            <v-btn small color="green" dark @click="MudarStatus(item)">
              Desbloquear
            </v-btn>
          </span>
          <span v-else>
            <v-btn small color="red" dark @click="BloquearLancamento(item)">
              Bloquear
            </v-btn>
          </span>
        </template>
        <template v-slot:no-data> Dados não encontrados! </template>
      </v-data-table>

      <!--========== FIM TABELA ===========-->
    </v-card>

    <!--============= CARD SLECIONAR TRIMESTRE ===============-->
    <template v-if="showSelecionarTrimestre">
      <v-row justify="center">
        <v-dialog v-model="showSelecionarTrimestre" persistent max-width="690">
          <v-card>
            <v-card-title class="headline"
              ><v-icon color="blue">info</v-icon>Bloquear Lançamento de
              nota</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="params[0].curso"
                    label="Curso"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="params[0].classeDesc"
                    label="Classe"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="editedItem.turma.descricao"
                    label="Turma"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="discipliaSelected"
                    label="Disciplina"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="params[0].autor"
                    label="Autor"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="editedItem.trimestre"
                    :items="trimestres"
                    item-value="id"
                    item-text="descricao"
                    @change="selecionarTrimestre()"
                    label="Trimestre"
                    return-object
                  ></v-select>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="fecharComponente()">
                Cancelar
              </v-btn>
              <v-btn color="green darken-1" text @click="finalizar()">
                Finalizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--============= FIM CARD SLECIONAR TRIMESTRE ===============-->
  </div>
</template>
<script>
import axios from "../../../plugins/axios";
const ls = require("local-storage");
import loading from "../../../components/loading.vue";
import Swal from "sweetalert2";
export default {
  components: {
    loading,
  },
  data: () => ({
    isLoading: false,
    cursos: [],
    anoacademicos: [],
    allTurmas: [],
    filtredTurmas: [],
    allDisciplinas: [],
    filterDisciplinas: [],
    headers: [
      { text: "#", value: "index" },
      { text: "Curso", align: "left", sortable: false, value: "curso" },
      { text: "Classe", value: "classe", sortable: false },
      { text: "Turma", value: "turma_desc", sortable: false },
      { text: "Disciplina", value: "desc_disc", sortable: false },
      { text: "Trimestre", value: "trimestre", sortable: false },
      { text: "Ação", value: "action", sortable: false },
    ],
    trimestres: [
      { id: 0, descricao: "Todos Trimestres" },
      { id: 1, descricao: "1º Trimestre" },
      { id: 2, descricao: "2º Trimestre" },
      { id: 3, descricao: "3º Trimestre" },
    ],
    editedItem: {
      curso: "",
      disciplina: "",
      classe: "",
      autor: ls.get("nomeUsuario"),
      turma: "",
      trimestre: null,
    },
    defaultItem: {
      curso: "",
      disciplina: "",
      classe: "",
      autor: "",
      turma: "",
      trimestre: null,
    },
    obrigqtorioRules: [(value) => !!value || "campo obrigatório."],

    dialog4: false,
    existeModeloCertificado: true,
    curso: { descricao: "" },
    disciplinas_certificado: [
      { descricao: "", controliddisciplina: 0, componente: 0 },
    ],
    item: null,
    anoacademico_chosen: null,
    dialog: false,
    cursoAlldisciplinas: [],
    isEditing: false,
    isLoading_: false,
    formValid: true,
    text: "",
    typemsg: "error",
    pautas: [],
    disciplinas: [],
    quant_insert: 1,
    alert: false,
    formValid2: false,
    dialog2: false,
    editedIndex: -1,
    params: [],
    showSelecionarTrimestre: false,
    discipliaSelected: "",
    selecinouTrimeste: false,
  }),

  computed: {
    anolectivo() {
      return ls.get("anolectivo");
    },
  },

  created() {
    this.initialize_curso();
    this.initializeClasse();
    this.initializeTurmas();
    this.initializeAllDisciplinas();
  },

  methods: {
    /**
     * Carregando todos os cursos
     */
    async initialize_curso() {
      this.isLoading = true;
      try {
        this.cursos = await axios.get("/cursoAll").then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Erro",
          "<p>Erro ao carregar a lista de cursos!</p>",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Carregando todas as classes
     */
    async initializeClasse() {
      this.isLoading = true;
      try {
        this.anoacademicos = await axios
          .get("/anoacademicoAll")
          .then((res) => res.data);

        this.anoacademicos = this.anoacademicos.filter(
          (a) => a.descricao != null
        );
      } catch (error) {
        Swal.fire(
          "Erro",
          "<p>Erro ao carregar a lista de classes!</p>",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Carregando todas as turmas
     */
    async initializeTurmas() {
      this.isLoading = true;
      try {
        this.allTurmas = await axios
          .get("/turmaFindWithEstudanteCount/" + "all")
          .then((res) => res.data);
      } catch (error) {
        Swal.fire(
          "Erro",
          "<p>Erro ao carregar a lista das turmas!</p>",
          "error"
        );
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Carregando todas as disciplinas
     */
    async initializeAllDisciplinas() {
      this.isLoading_ = true;
      try {
        this.allDisciplinas = await axios
          .get("/carregarDisciplinaBloqueadas")
          .then((res) => res.data);
        this.exibirTabela();
      } catch (error) {
        Swal.fire(
          "Erro",
          "<p>Erro ao carregar a lista das disciplinas!</p>",
          "error"
        );
      } finally {
        this.isLoading_ = false;
      }
    },

    filtrarTurma() {
      if (this.editedItem.curso && this.editedItem.classe) {
        this.filtredTurmas = this.allTurmas.filter(
          (t) =>
            t.idCurso == this.editedItem.curso.idCurso &&
            t.idAno_Academico == this.editedItem.classe.idAno_Academico &&
            t.anoLectivo == this.anolectivo
        );
        this.editedItem.turma = null;
        this.exibirTabela();
      }
    },

    exibirTabela() {
      if (this.editedItem.turma) {
        this.filterDisciplinas = this.allDisciplinas.filter(
          (d) => d.pkTurma == this.editedItem.turma.pkTurma
        );
      } else {
        this.filterDisciplinas = [];
      }
    },

    selecionarTrimestre() {
      for (let i = 0; i < this.params.length; i++) {
        this.params[i].trimestre = this.editedItem.trimestre.id;
      }
      this.selecinouTrimeste = true;
    },

    fecharComponente() {
      this.showSelecionarTrimestre = false;
      this.selecinouTrimeste = false;
      this.editedItem.trimestre = null;
      this.params = [];
    },

    bloquearTodasDisciplinas() {
      try {
        let disciplinasToBlock = this.filterDisciplinas.filter(
          (d) => (d.pkTurma = this.editedItem.turma.pkTurma)
        );

        let allBlockDisciplina = [];

        disciplinasToBlock.forEach((element) => {
          let value = {
            disciplina: element.desc_disc,
            disciplinaId: element.iddisciplina,
            curso: element.curso,
            cursoId: element.idCurso,
            autor: ls.get("nomeUsuario"),
            classe: element.classe,
            turma: this.editedItem.turma.pkTurma,
            classeDesc:
              element.classe === 1
                ? "10ª"
                : element.classe === 2
                ? "11ª"
                : element.classe === 3
                ? "12ª"
                : element.classe === 4
                ? "13ª"
                : "N/A",
          };

          allBlockDisciplina.push(value);
        });
        this.essa(allBlockDisciplina);
      } catch (error) {
        Swal.fire("Informação", "Erro ao desbloquear o lançamento!", "error");
      }
    },

    async desbloquearTodasDisciplinas() {
      try {
        let disciplinasToUnblockAll = this.filterDisciplinas.filter((d) => (d.pkTurma = this.editedItem.turma.pkTurma && d.idControlopauta != null && d.status != 0));
        let disciplinasToUnblock= []

        if (disciplinasToUnblockAll.length) {
          Swal.fire({
            title: "Desbloquear todas as disciplinas?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "green",
            cancelButtonColor: "#d33",
            cancelButtonText: "Cancelar",
            confirmButtonText: "Confirmar",
            reverseButtons: true,
          }).then(async (result) => {
            if (result.isConfirmed) {
              disciplinasToUnblockAll.forEach((element) => {
                let value = { idControlopauta: element.idControlopauta};
                disciplinasToUnblock.push(value);
              });
    
              let result = await axios.post("/desbloquearAllDisciplina", disciplinasToUnblock)
              .then((res) => res.data);
    
              if (result.affectedRows >= 1) {
                Swal.fire("Informação", "<p>Operação realizada com sucesso!</p>", "success");
                this.initializeAllDisciplinas();
              } else {
                Swal.fire("Informação", "Erro ao desbloquear o lançamento!", "error");
              }
            }
          });
        } else {
          Swal.fire("Informação", "<p>A turma não tem disciplinas bloqueadas", "info");
        }
      } catch (error) {
        Swal.fire("Informação", "Erro ao desbloquear o lançamento!", "error");
      }
    },

    /**
     * Mudando o status de um bloqueio já realizado
     */
    async MudarStatus(item) {
      this.isLoading = true;
      try {
        Swal.fire({
          title: "Desbloquear lançamento?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "green",
          cancelButtonColor: "#d33",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Confirmar",
          reverseButtons: true,
        }).then(async (result) => {
          if (result.isConfirmed) {
            let result = await axios
              .post("/mudarStatus_controloPauta", {
                item: item.idControlopauta,
              })
              .then((res) => res.data);
            if (result.affectedRows >= 1) {
              Swal.fire(
                "Informação",
                "<p>Operação realizada com sucesso!</p>",
                "success"
              );
              this.initializeAllDisciplinas();
            }
          }
        });
      } catch (error) {
        Swal.fire("Informação", "Erro ao realizar a operação", "error");
      } finally {
        this.isLoading = false;
      }
    },

    /**
     * Bloqueando o lançamento de nota
     */
    async BloquearLancamento(item) {
      if (this.$refs.form.validate()) {
        this.isLoading = true;
        let values = [];
        try {
          let params = {
            disciplina: item.desc_disc,
            disciplinaId: item.iddisciplina,
            curso: item.curso,
            cursoId: item.idCurso,
            autor: ls.get("nomeUsuario"),
            classe: item.classe,
            turma: item.pkTurma,
            classeDesc:
              item.classe === 1
                ? "10ª"
                : item.classe === 2
                ? "11ª"
                : item.classe === 3
                ? "12ª"
                : item.classe === 4
                ? "13ª"
                : "N/A",
          };
          values.push(params);
          this.essa(values);
        } catch (error) {
          Swal.fire(
            "Informação",
            "Erro ao bloquear o lançamento de nota!",
            "error"
          );
        } finally {
          this.isLoading = false;
        }
      }
    },

    essa(disciplinaArray) {
      this.params = disciplinaArray;
      if (this.params.length > 1) this.discipliaSelected = "Todas disciplinas";
      else this.discipliaSelected = this.params[0].disciplina;
      this.showSelecionarTrimestre = true;
    },

    async finalizar() {
      try {
        if (this.selecinouTrimeste) {
          let result = await axios
            .post("/bloquearAllDisciplina", this.params)
            .then((res) => res.data);

          if (result.affectedRows >= 1) {
            Swal.fire(
              "Informação",
              "<p>Operação realizada com sucesso!</p>",
              "success"
            );
            this.fecharComponente();
            this.initializeAllDisciplinas();
          } else {
            Swal.fire(
              "Informação",
              "Erro ao bloquear o lançamento de nota!",
              "error"
            );
          }
        } else {
          Swal.fire(
            "Informação",
            "Por favor, selecione o trimestre!",
            "warning"
          );
        }
      } catch (error) {
        Swal.fire("Informação", "Erro ao realizar o bloqueio!", "error");
      }
    },

    validate() {
      this.$refs.form.validate();
    },

    resetValidation() {
      this.$refs.form.resetValidation();
    },
  },
};
</script>
